// eslint-disable-next-line
/* eslint-disable */
import { Endpoint } from "../config";
// import axios from "axios";
export default {
  async login(email, password) {
    var url = `${Endpoint}/api/Auth/Login`;
    try {
      return await axios.post(url, {
        email: email,
        password: password
      });
    } catch (err) {
      throw {
        statusCode: err.response.status,
        message: err.response.data.message
      };
    }
  },
  async register(fullname, email, password) {
    var url = `${Endpoint}/api/Auth/Register`;
    let response = null;
    try {
      response = await axios.post(url, {
        fullname: fullname,
        email: email,
        password: password
      });
    } catch (err) {
      throw {
        statusCode: err.response.status,
        message: err.response.data[Object.keys(err.response.data)[0]][0]
      };
    }

    return response;
  },
  refreshAccessToken() {
    return axios.post(`${Endpoint}/api/Auth/Refresh`, {
      token: this.getToken(),
      refreshToken: this.getRefreshToken()
    });
  },
  getToken() {
    return localStorage.getItem("token");
  },
  getRefreshToken() {
    return localStorage.getItem("refreshToken");
  },
  parseJwt(token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(window.atob(base64));
  },
  setStorage(user) {
    localStorage.setItem("token", user.token);
    localStorage.setItem("fullname", user.fullname);
    localStorage.setItem("email", user.username);
    localStorage.setItem("refreshToken", user.refreshToken);
  },
  removeStorage() {
    localStorage.removeItem("token");
    localStorage.removeItem("fullname");
    localStorage.removeItem("email");
    localStorage.removeItem("refreshToken");
  },
  async forgotPassword(email) {
    let url = `${Endpoint}/api/auth/ForgotPassword`;
    let response = null;
    try {
      response = await axios.post(url, {
        email: email
      });
    } catch (err) {
      throw {
        statusCode: err.response.status,
        message: err.response.data.message
      };
    }

    return response;
  },
  async resetPassword(code, email, password) {
    let url = `${Endpoint}/api/auth/ResetPassword`;
    let response = null;
    try {
      response = await axios.post(url, {
        code: code,
        email: email,
        password: password
      });
    } catch (err) {
      throw {
        statusCode: err.response.status,
        message: err.response.data.message
      };
    }

    return response;
  }
};
